import { styled } from '@mui/material/styles';
import KTable from '../../../KTable/index.js';

var PREFIX = "KTableContainer";
var classes = {
    actionCell: "".concat(PREFIX, "-actionCell"),
    ellipsisCell: "".concat(PREFIX, "-ellipsisCell")
};
var StyledKTableContainer = styled(KTable)(function () {
    var _a;
    return (_a = {
            "& th": {
                fontWeight: "bold"
            },
            tableLayout: "fixed"
        },
        _a["& .".concat(classes.actionCell)] = {
            textAlign: "right"
        },
        _a["& .".concat(classes.ellipsisCell)] = {
            "& .MuiBox-root": {
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden"
            }
        },
        _a);
});

export { classes, StyledKTableContainer as default };
//# sourceMappingURL=index.styled.js.map
